import React from "react";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Stack from "@mui/material/Stack";

class MoreOptionsPopover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.anchorRef = React.createRef();
    this.prevOpen = false;
  }

  handleToggle = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  handleClose = (event) => {
    if (
      event &&
      this.anchorRef &&
      this.anchorRef.current &&
      this.anchorRef.current.contains(event.target)
    ) {
      return;
    }
    this.setState({ open: false });
  };

  handleListKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      this.setState({ open: false });
    } else if (event.key === "Escape") {
      this.setState({ open: false });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.open === true && this.state.open === false) {
      this.anchorRef.current.focus();
    }
  }

  render() {
    const { children, handleClick, itemsOfMenu = [] } = this.props;
    const { open } = this.state;
    const hasItemsOfMenu = Array.isArray(itemsOfMenu) && itemsOfMenu.length > 0;

    return (
      <Stack direction="row" spacing={2}>
        <div>
          <Button
            ref={this.anchorRef}
            id="composition-button"
            aria-controls={open ? "composition-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-haspopup="true"
            onClick={this.handleToggle}
            sx={{ minWidth: "auto", padding: "0px" }}
          >
            {children}
          </Button>
          <Popper
            open={open}
            anchorEl={this.anchorRef.current}
            role={undefined}
            placement="bottom-start"
            transition
            disablePortal
            sx={{ zIndex: 999 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom-start" ? "left top" : "left bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="composition-menu"
                      aria-labelledby="composition-button"
                      onKeyDown={this.handleListKeyDown}
                    >
                      {hasItemsOfMenu &&
                        itemsOfMenu.map((itemOfMenu, index) => {
                          if (!itemOfMenu) {
                            return null;
                          }

                          return (
                            <MenuItem
                              key={`item-of-menu--${index}`}
                              onClick={() => {
                                if (handleClick) {
                                  handleClick(itemOfMenu.id);
                                }
                                this.handleClose();
                              }}
                              sx={{
                                padding: "0px",
                              }}
                            >
                              {itemOfMenu.label}
                            </MenuItem>
                          );
                        })}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </Stack>
    );
  }
}

export default MoreOptionsPopover;
